<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!user">
      <span class="loader"></span>
    </span>
    <user-form
      v-if="user"
      :loading="loading"
      :userData="user"
      :formErrors="formErrors"
      @userSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import UserForm from "../partials/UserForm.vue";
import requestErrorMixin from "@/mixins/request-error-mixin";
import defaultUser from "../defaultUser";

export default {
  layout: "DashboardLayout",

  components: { UserForm },

  mixins: [alertLeave, requestErrorMixin],

  props: {
    userId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      user: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;

      try {
        await this.$store.dispatch("users/get", this.userId);
        this.user = { ...this.user, ...this.$store.getters["users/user"] };
        if(!this.user.roles.length){
          this.user.roles = defaultUser.roles
        }
        this.user.is_staff = !!this.user.is_staff;
        this.user.restrict_to_locations = !!this.user.restrict_to_locations;
        this.loading = false;
      } catch (error) {
        this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async handleSubmit(user) {
      this.loading = true;
      const userData = cloneDeep(user);

      try {
        await this.$store.dispatch("users/update", userData);
        this.$notify({
          type: "success",
          timeout: 3000,
          message: this.$t("USERS.USER_UPDATED"),
        });
        this.$emit("onViewUser", user, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
